/* global axios */
export default class UsageService {
  constructor() {
    this.axios = axios;
  }
  save(formData) {
    return this.axios.post('service/usage/store', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
}
